export default function switchText ($elems) {
	$elems.each((i, el) => {
		let $el = $(el);
		let index = 0;
		let arrText = $el.data('switch-text');
		let swt = ($node) => {
			$node.text(arrText[index]);
			index++;
			if (index >= arrText.length) {
				index = 0;
			}
		};

		swt($el.is('.button') ? $el.find('.button__text') : $el);

		$el.on('click.switch-text', (e) => {
			let $this = $(e.currentTarget);
			swt($this.is('.button') ? $this.find('.button__text') : $this);
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/switchText.js